import ReportChartUtils from '../../ReportChartUtils'
import BaseFormatterCreator from './BaseFormatterCreator'

export default class ChartFormatterCreator extends BaseFormatterCreator {
    getFormatPieLabelFunction(selectedValueType){
        return (label) => {
            return label.substr(0, 65)
        }
    }

    getFormatCategoryFunctionForChart(selectedCategoryType, escape, partsLimit, recursively){
        return ReportChartUtils.getFormatCategoryFunctionForChart(selectedCategoryType, this.DATE_FORMAT, escape, partsLimit, recursively)
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/charts/parametersFormatters/ChartFormatterCreator.js